
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Select from "./Select.vue";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules";
import { ManufacturerSearchCriteria } from "../../models/api/system/manufacturers";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class AgentManufacturerSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  localManufacturers: any = [];

  @Prop({ default: () => null })
  public manufacturers: any[] = null;

  @Prop({ default: null })
  public billTo: string;

  @Prop({ default: 0 })
  public deliveryForId: number;

  @Prop({ default: false })
  public preload: true;

  async created() {
    if (this.preload) {
      let criteria: ManufacturerSearchCriteria = { name: "", billTo: this.billTo, deliveryForId: this.deliveryForId };
      let results = await systemModule.searchManufacturersByName(criteria);
      this.localManufacturers = results.map(x => ({ label: x.name, value: x.id }));
    } else {
      let result = await systemModule.getManufacturer(this.localValue);
      if(result)
        this.localManufacturers = [ {label: result.name, value: result.id} ];
    }
  }

  async search(value, loading) {
    loading(true);
    try {
      let criteria: ManufacturerSearchCriteria = { name: value, billTo: this.billTo, deliveryForId: this.deliveryForId };
      let results = await systemModule.searchManufacturersByName(criteria);

      this.localManufacturers = results.map(x => ({ label: x.name, value: x.id }));
    } finally {
      loading(false);
    }
  }

  get items() {
    if (this.manufacturers) return this.manufacturers;
    return this.localManufacturers;
  }

  @Watch("deliveryForId")
  @Watch("billTo")
  async billToChanged(newVal, oldVal) {
      let criteria: ManufacturerSearchCriteria = { name: "", billTo: this.billTo, deliveryForId: this.deliveryForId };
      let results = await systemModule.searchManufacturersByName(criteria);
      this.localManufacturers = results.map(x => ({ label: x.name, value: x.id }));
  }
}
